import {Modal, Form, Input, Button, Space, Alert} from 'antd';

/**
 * Revert an anonymous-origin ticket that was linked to the wrong account.
 *
 * After unlink: `userId` returns to null; `origin` stays ANONYMOUS; a
 * SYSTEM_EVENT records the reason. The reason is required — it's the
 * audit trail for *why* the account was detached.
 */
export const UnlinkAnonymousTicketModal = ({
  isOpen,
  onClose,
  onUnlink,
  loading,
  linkedUserDisplay,
}) => {
  const [form] = Form.useForm();

  const handleFinish = values => {
    onUnlink({reason: (values.reason || '').trim()}, () => {
      form.resetFields();
      onClose();
    });
  };

  return (
    <Modal
      title="Unlink Account from Ticket"
      open={isOpen}
      onCancel={() => {
        onClose();
        form.resetFields();
      }}
      footer={null}
      width={500}
      destroyOnClose>
      <Alert
        type="warning"
        showIcon
        style={{marginBottom: 16}}
        message={
          linkedUserDisplay
            ? `You'll detach ${linkedUserDisplay} from this ticket. The ticket stays anonymous and the customer keeps the ticket id as their credential.`
            : "You'll detach the account from this ticket. The ticket stays anonymous and the customer keeps the ticket id as their credential."
        }
      />
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="reason"
          label="Reason"
          rules={[{required: true, message: 'A reason is required.'}]}>
          <Input.TextArea
            rows={3}
            placeholder="e.g. Linked to the wrong account during verification."
            maxLength={500}
            showCount
          />
        </Form.Item>
        <Form.Item style={{marginBottom: 0}}>
          <Space style={{width: '100%', justifyContent: 'flex-end'}}>
            <Button
              onClick={() => {
                onClose();
                form.resetFields();
              }}>
              Cancel
            </Button>
            <Button danger type="primary" htmlType="submit" loading={loading}>
              Unlink
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};
